import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import GalleryData from "./gallery-data.json"; // adjust the path if needed
import { AnimatePresence, motion, useMotionValue } from "framer-motion";

const isVideo = (filename) => /\.(mp4|webm|ogg)$/i.test(filename);

export default function Gallery() {
  const [showModal, setShowModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);

  const videos = GalleryData.galleryMediaItems.filter(item => isVideo(item.fileName));
  const images = GalleryData.galleryMediaItems.filter(item => !isVideo(item.fileName));

  const openImageModal = (index) => {
    setCurrentImageIndex(index);
    setModalMedia({ type: "image", src: require(`../../images/gallery/${images[index].fileName}`) });
    setShowModal(true);
  };

  const openVideoModal = (mediaSrc) => {
    setModalMedia({ type: "video", src: mediaSrc });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMedia(null);
    setCurrentImageIndex(null);
  };

  const showPrevImage = () => {
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    openImageModal(newIndex);
  };

  const showNextImage = () => {
    const newIndex = (currentImageIndex + 1) % images.length;
    openImageModal(newIndex);
  };
  const titleRef = useRef(null);
  
    useEffect(() => {
      const titleEl = titleRef.current; // Cache ref
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("animate-lines");
            } else {
              entry.target.classList.remove("animate-lines");
            }
          });
        },
        { threshold: 0.3 }
      );
  
      if (titleEl) observer.observe(titleEl);
  
      return () => {
        if (titleEl) observer.unobserve(titleEl); // Use cached ref
      };
    }, []);

  return (
    
    <section className="section" id="gallery">
              <Container>
                {/* Section Title */}
                <Row>
                  <Col md={12}>
                    <div className="section-title-box">
                      <h1 className="section-title" ref={titleRef}>
                        <span className="text-primary">Media</span> Gallery
                        {/* Decorative lines for title styling */}
                        <div className="title-line before-line" />
                        <div className="title-line after-line" />
                      </h1>
                    </div>
                  </Col>
                </Row>
                </Container>
      <Container>
        {/* ===========================
      Concept Plan
=========================== */}

<Row className="mb-5">

<Col>

  <h3 className="text-center text-white fw-bold mb-4">
    <span className="text-primary">
      Concept
    </span>{" "}
    Plan
  </h3>

  <div className="rounded overflow-hidden shadow-lg">

  <img
  src={require("../../images/gallery/concept-plan.jpg")}
  alt="North BB Creek Concept Plan"
  className="img-fluid w-100 rounded shadow"
  style={{
    maxHeight: "700px",
    objectFit: "contain",
    cursor: "pointer"
  }}
  onClick={() => {
    setCurrentImageIndex(null);
    setModalMedia({
      type: "image",
      src: require("../../images/gallery/concept-plan.jpg"),
    });
    setShowModal(true);
  }}
/>
  </div>

</Col>

</Row>
        {/* Videos */}
        {videos.map((item, index) => {
          const mediaFile = item.fileName;
          const mediaSrc = require(`../../images/gallery/${mediaFile}`);

          return (
            <Row key={`video-${index}`} className="mb-2">
  <Col>
    <div
      className="video-wrapper rounded overflow-hidden shadow-sm position-relative"
      style={{ height: "300px", cursor: "pointer" }}
      onClick={() => openVideoModal(mediaSrc)}
    >
      <video
        className="w-100 h-100 object-fit-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
      >
        <source src={mediaSrc} type="video/mp4" />
      </video>

      {/* Play Icon */}
      <div className="play-icon-overlay position-absolute top-50 start-50 translate-middle">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="60"
          fill="white"
          viewBox="0 0 16 16"
        >
          <path d="M6.271 11.813V4.188l5.458 3.813-5.458 3.812z" />
          <path d="M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" />
        </svg>
      </div>

      {/* Watch on YouTube Button */}
      {item.youtubeUrl && (
        <a
          href={item.youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-danger position-absolute bottom-0 end-0 m-2 px-3 py-1 small"
          style={{ zIndex: 5 }}
          onClick={(e) => e.stopPropagation()} // Prevent modal from opening
        >
          ▶ Watch on YouTube
        </a>
      )}
    </div>
  </Col>
</Row>

          );
        })}

        {/* Images */}
        <Row>
          {images.map((item, index) => {
            const mediaFile = item.fileName;
            const mediaSrc = require(`../../images/gallery/${mediaFile}`);

            return (
              <Col key={`img-${index}`} md={6} lg={3} className="mb-2">
                <div
                  className="gallery-hover rounded overflow-hidden shadow-sm"
                  onClick={() => openImageModal(index)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={mediaSrc}
                    alt={`gallery-media-${index}`}
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>

      {/* Modal Preview */}
      <Modal show={showModal} onHide={closeModal} centered size="lg">
        <Modal.Body className="p-0 position-relative bg-black text-center">
          {/* Close Button */}
          <button
            className="btn btn-light position-absolute top-0 end-0 m-2"
            onClick={closeModal}
          >
            ✕
          </button>

          {/* Image Viewer with Navigation */}
          {modalMedia?.type === "image" ? (
            <>
              <img
                src={modalMedia.src}
                alt="modal-media"
                className="w-100 h-auto"
                style={{ maxHeight: "80vh", objectFit: "contain" }}
              />
              {currentImageIndex !== null && (
  <>
    <button
      className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2"
      onClick={showPrevImage}
    >
      ‹
    </button>

    <button
      className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2"
      onClick={showNextImage}
    >
      ›
    </button>
  </>
)}
            </>
          ) : modalMedia?.type === "video" ? (
            <video
              src={modalMedia.src}
              controls
              autoPlay
              className="w-100 h-auto"
            />
          ) : null}
        </Modal.Body>
      </Modal>
    </section>
  );
}
